import './OrgIndicatorsWidget.css';

import useOrgStatusAreaIndicators from '../../../../b2b-plans/hooks/useOrgStatusAreaIndicators';
import { formatPercentage } from '../../../../b2b-common/helpers';
import AreaIndicatorItemList from '../../../../b2b-plans/components/area-indicators/AreaIndicatorItemList';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';

const OrgIndicatorsWidget = ({ widget, status = null }) => { 
    const { t } = useB2BTranslation('b2b-reporting');
    const { organizationAreaIndicatorsData, percentage, totalCount, isSearching } = useOrgStatusAreaIndicators(status);
    const count = organizationAreaIndicatorsData?.length;
    
    return (
        <div className={`OrgIndicatorsWidget-container ${status}`}>
            <div className='OrgIndicatorsWidget-title'>
                {widget.widgetConfig.title}
            </div>
            <div className='OrgIndicatorsWidget-metric'>
                <div className='OrgIndicatorsWidget-metric-value'>
                    {formatPercentage(percentage, 0)}
                    <span className='OrgIndicatorsWidget-percent-sign'>%</span>
                </div>
                <div className='OrgIndicatorsWidget-metric-label'>
                    {`${count || 0} ${t('out of')} ${totalCount} ${t('indicators')}`}
                </div>
            </div>
            <div className='OrgIndicatorsWidget-content'>
                {organizationAreaIndicatorsData?.map((item, index) => (
                    <AreaIndicatorItemList key={index} areaIndicator={item} />
                ))}
            </div>
        </div>
    );
};

export default OrgIndicatorsWidget;